module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("Popup")]), _vm._v(" "), _c('p', [_vm._v("Popup component, did you note that semantic-ui has a Popup module that you can use without javascript? But, if you need something more \"complex\", This is something helpful.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui button popup-example-element"
  }, [_vm._v("Try here the beautiful Popup")]), _vm._v(" "), _c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui sub header"
  }, [_vm._v("Position*")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "dropdownId": "dropdown-positions",
      "options": _vm.positions,
      "value": _vm.position,
      "customClass": "large fluid label"
    },
    on: {
      "update:value": function($event) {
        _vm.position = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "two wide column"
  }, [_c('div', {
    staticClass: "ui sub header"
  }, [_vm._v("Trigger")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "dropdownId": "dropdown-triggers",
      "options": _vm.triggers,
      "value": _vm.trigger,
      "customClass": "large fluid label"
    },
    on: {
      "update:value": function($event) {
        _vm.trigger = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui sub header"
  }, [_vm._v("Transitions")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "dropdownId": "dropdown-transitions",
      "options": _vm.transitions,
      "value": _vm.transition,
      "customClass": "large fluid label"
    },
    on: {
      "update:value": function($event) {
        _vm.transition = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("* Position: If space is not available, it will automatically search for a similar alternative position to use.")]), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Usage")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Props")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('popup', {
    attrs: {
      "popupId": "nice-popup",
      "trigger": _vm.trigger.value,
      "targetSelector": ".popup-example-element",
      "options": _vm.popupOptions,
      "customClass": "flowing"
    }
  }, [_c('div', {
    staticClass: "ui horizontal segments"
  }, [_c('div', {
    staticClass: "ui center aligned segment"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Selected Position")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.position.text))])]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Selected Trigger")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.trigger.text))])]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Selected Transition")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transition.text))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/popup.html"
    }
  }, [_vm._v(" you can see all documentation here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment code"
  }, [_c('pre', [_vm._v("\n        import { Popup } from 'semvue';\n\n        export default {\n            components: {\n                Popup,\n            },\n        }\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment code"
  }, [_c('pre', [_vm._v("\n        <popup popupId=\"nice-popup\" :trigger=\"trigger.value\" targetSelector=\".popup-example-element\" :options=\"popupOptions\" customClass=\"fluid\">\n            *your custom popup html here*\n        </popup>\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui definition table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("popupId")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Is a div id for popup (used to get your custom complex popup and start it on semantic-ui)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("trigger")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Used to toggle popup on element.\n                    "), _c('p', [_c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/popup.html"
    }
  }, [_vm._v(" you can see all popup triggers here")])]), _vm._v(" "), _c('p', [_vm._v("*Attention, according on semantic-ui docs, sometimes your overrides on options will need diferent styles (e.g min-width) on your popup")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("targetSelector")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Selector of element where popup should appear (could be #elementId or .element-class)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("curstomClass")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String empty")]), _vm._v(" "), _c('td', [_vm._v("Used to put any aditional class inside rating div "), _c('br'), _vm._v("\n                    e.g. class=\"ui customClass popup\"\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("Object Empty")]), _vm._v(" "), _c('td', [_vm._v("Overrides component options.\n                    "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/popup.html"
    }
  }, [_vm._v(" You can see all options here")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d72684"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupDoc.vue
// module id = 142
// module chunks = 1